export const set_stock_items = (stock_items) => {
    return {
        type: 'SET_STOCK_ITEMS',
        stock_items
    };
}
